import { BaseModel } from "@blue-chip/core";
import Flag from "./Flag";

export default class Brand extends BaseModel {
  static get hasMany() {
    return [Flag];
  }
}
